const DEV_RECAPTCHA_SITE_KEY = '6LfuPDAUAAAAAB9hPsja-CDKHS0T0bjMX_RmdU7g';
const PROD_RECAPTCHA_SITE_KEY = '6LdKSTAUAAAAAL3G5acAfoHSYguMb3GNWV8CQ3h1';

const ENV_FLAGS = [
  {
    host: [
      /dev\.spotify\.(net|com)/,
    ],
    flags: {
      env: 'dev',
      recaptchaSiteKey: DEV_RECAPTCHA_SITE_KEY,
      swEnabled: false,
    },
  },
  {
    host: [
      /localhost/,
      /adstudio-local\.spotify\.com/,
    ],
    flags: {
      env: 'dev',
      recaptchaSiteKey: DEV_RECAPTCHA_SITE_KEY,
      swEnabled: false,
    },
  },
  {
    host: [
      /(adgen|adstudio)\.spotify\.(net|com)/,
    ],
    flags: {
      env: 'prod',
      recaptchaSiteKey: PROD_RECAPTCHA_SITE_KEY,
      swEnabled: false,
    },
  },
];

function confMatches(conf, hostname) {
  if (conf.host) {
    const hostMatches = conf.host
      .filter(h => h.test(hostname))
      .length > 0;
    if (!hostMatches) {
      return false;
    }
  }
  return true;
}

let flags = {};
let _flagsSet = false;

export function setFlags(hostname) {
  flags = ENV_FLAGS
    .filter(conf => conf.flags && confMatches(conf, hostname))
    .map(conf => conf.flags)
    .reduce((merged, _flags) => ({ ...merged, ..._flags }), {});
  _flagsSet = true;
}

export function getFlag(flagKey) {
  if (!_flagsSet) {
    setFlags(window.location.hostname);
  }

  return flags[flagKey];
}



// WEBPACK FOOTER //
// ./src/config/flags.js